import CommentTask from "../model/CommentTask";
import { promiseRequest } from './ServiceApi';
import { ServiceApi } from "./ServiceApiWithLoading";

export default class CommentTaskApi extends ServiceApi<CommentTask>  {

    constructor(loading = false) {
        super('commentTask', loading);
        this.addEmote = this.addEmote.bind(this);
    }

    async addEmote(commentTaskId: string | number, emoteId: number) {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `${commentTaskId}/addEmote/`, 'POST', { emote_id: emoteId }, true));
        return result;
    }

    async getAvailableDislikes(): Promise<{ available: number }> {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + 'availableDislikes/', 'GET', undefined, true));
        return result;
    }

    async getEmoteLimits(): Promise<EmoteLimitInfo[]> {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + 'emoteLimits/', 'GET', undefined, true));
        return result;
    }

}

export interface EmoteLimitInfo {
    emote_id: number;
    name: string;
    base_daily_limit: number;
    extra_from_shop: number;
    effective_daily_limit: number;
    used_today: number;
    remaining: number | null;
    weekly_limit: number;
    weekly_available: boolean | null;
    requires_shop_purchase: boolean;
}